import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Label,
  Input,
  Form,
  FormGroup,
  FormFeedback,
  Col,
  Button,
} from "reactstrap";
import { useFormik } from "formik";
import * as yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getDocumentsTypes } from "../../../helpers/AuthType/authBackend";
import { setAuthorization } from "../../../helpers/api_helper";
import {
  getPublicCountries,
  getPublicGenders,
} from "../../../helpers/dataBackend";
import { splitFileIntoChunksBase64 } from "shared/fileUtils";
import { BiLoaderAlt, BiCheckCircle } from "react-icons/bi";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
interface BasicInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const RepresentativeInformation = ({
  onSubmit,
  onBack,
  data,
}: BasicInformationProps) => {
  //meta title
  document.title = "Ditobanx";

  const [selectedSelfie, setSelectedSelfie] = useState<any[]>([]);
  const [selectedFileFront, setSelectedFileFront] = useState<any[]>([]);
  const [selectedFileBack, setSelectedFileBack] = useState<any[]>([]);
  const [frontValidated, setFrontValidated] = useState(false);
  const [backValidated, setBackValidated] = useState(false);
  const [selfieValidated, setSelfieValidated] = useState(false);
  const [base64Front, setBase64Front] = useState<any>(null);
  const [base64Back, setBase64Back] = useState<any>(null);
  const [base64Selfie, setBase64Selfie] = useState<any>(null);
  const [documentType, setDocumentType] = useState<any[]>([]);
  const [countries, setCountries] = useState<any[]>([]);
  const [gender, setGenders] = useState<any[]>([]);
  const [typeDocument, setTypeDocument] = useState<any>("");
  const [document1, setDocument1] = useState<any>(null);
  const [documentValidated1, setDocumentValidated1] = useState<boolean>(false);

  //ESTADOS
  const [loadingPassport, setLoadingPassport] = useState(false);
  const [loadingFront, setLoadingFront] = useState(false);
  const [loadingBack, setLoadingBack] = useState(false);
  const [loadingSelfie, setLoadingSelfie] = useState(false);

  // Función para el documento (permite varios archivos)
  const onDropDocsFront = useCallback((acceptedFiles: any[]) => {
    const validFiles = acceptedFiles.filter((file) => {
      if (file.size > MAX_FILE_SIZE) {
        alert(
          `El archivo ${file.name} supera el tamaño máximo permitido (2 MB).`
        );
        return false;
      }
      return true;
    });

    const mappedFiles = validFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );

    setSelectedFileFront((prevFiles) => [...prevFiles, ...mappedFiles]);
  }, []);

  // Función para el documento (permite varios archivos)
  const onDropDocsBack = useCallback((acceptedFiles: any[]) => {
    const validFiles = acceptedFiles.filter((file) => {
      if (file.size > MAX_FILE_SIZE) {
        alert(
          `El archivo ${file.name} supera el tamaño máximo permitido (2 MB).`
        );
        return false;
      }
      return true;
    });

    const mappedFiles = validFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );

    setSelectedFileBack((prevFiles) => [...prevFiles, ...mappedFiles]);
  }, []);

  // Función para la selfie (solo permite un archivo)
  const onDropSelfie = useCallback((acceptedFiles: any[]) => {
    const validFiles = acceptedFiles.filter((file) => {
      if (file.size > MAX_FILE_SIZE) {
        alert(
          `El archivo ${file.name} supera el tamaño máximo permitido (2 MB).`
        );
        return false;
      }
      return true;
    });

    const mappedFiles = validFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );

    setSelectedSelfie(mappedFiles.slice(0, 1)); // solo uno
  }, []);

  // Dropzone para documentos
  const { getInputProps: getDocInputProps, open: openDocFront } = useDropzone({
    onDrop: onDropDocsFront,
    noClick: true,
    noKeyboard: true,
    accept: {
      "image/*": [],
    },
    maxFiles: 1,
  });

  // Dropzone para documentos
  const { getInputProps: getDocInputPropsBack, open: openDocBack } =
    useDropzone({
      onDrop: onDropDocsBack,
      noClick: true,
      noKeyboard: true,
      accept: {
        "image/*": [],
      },
      maxFiles: 1,
    });

  // Dropzone para selfie (se limita a un solo archivo)
  const { getInputProps: getSelfieInputProps, open: openSelfie } = useDropzone({
    onDrop: onDropSelfie,
    noClick: true,
    noKeyboard: true,
    accept: {
      "image/*": [],
    },
    maxFiles: 1,
  });

  // ELIMAR DOCUMENTOS CARGADOS
  const removeDoc = (idx: number) => {
    setSelectedFileFront((p) => p.filter((_, i) => i !== idx));
    setFrontValidated(false);
    setDocumentValidated1(false);
    setLoadingFront(false);
    setLoadingPassport(false);
  };

  const removeDocBack = (idx: number) => {
    setSelectedFileBack((p) => p.filter((_, i) => i !== idx));
    setBackValidated(false);
    setLoadingBack(false);
  };

  const removeSelfie = (idx: number) => {
    setSelectedSelfie((p) => p.filter((_, i) => i !== idx));
    setSelfieValidated(false);
    setLoadingSelfie(false);
  };
  // ---------------------

  const uploadFileChunks = async (file: File, type: string) => {
    const chunks = await splitFileIntoChunksBase64(file);
    const uploadId = `${file.name}-${Date.now()}`;

    return { chunks, uploadId };
  };

  const validarPhotoUploaded = async (type: string) => {
    try {
      if (type === "Passport") {
        setLoadingPassport(true);
        const chunksImg = await uploadFileChunks(selectedFileFront[0], type);
        setDocument1({ name: "Passport", chunksImg });
        setDocumentValidated1(true);
      }
      if (type === "front") {
        setLoadingFront(true);
        const chunksImg = await uploadFileChunks(selectedFileFront[0], type);
        setBase64Front({ name: "front", chunksImg });
        setFrontValidated(true);
      }
      if (type === "back") {
        setLoadingBack(true);
        const chunksImg = await uploadFileChunks(selectedFileBack[0], type);
        setBase64Back({ name: "back", chunksImg });
        setBackValidated(true);
      }
      if (type === "selfie") {
        setLoadingSelfie(true);
        const chunksImg = await uploadFileChunks(selectedSelfie[0], type);
        setBase64Selfie({ name: "selfie", chunksImg });
        setSelfieValidated(true);
      }
    } catch (err) {
      console.error(err);
      alert("Ocurrió un error al subir la imagen.");
    } finally {
      // detener el spinner del tipo correspondiente
      if (type === "Passport") setLoadingPassport(false);
      if (type === "front") setLoadingFront(false);
      if (type === "back") setLoadingBack(false);
      if (type === "selfie") setLoadingSelfie(false);
    }
  };

  const getData = async () => {
    const responsePublicToken = localStorage.getItem("publicToken");
    setAuthorization(responsePublicToken);
    const response = await getDocumentsTypes();
    setDocumentType(JSON.parse(response.data));
    const responseGender = await getPublicGenders();
    setGenders(JSON.parse(responseGender.data));
    const responseCountries = await getPublicCountries();
    setCountries(JSON.parse(responseCountries.data));
  };
  useEffect(() => {
    getData();
  }, []);

  const formik: any = useFormik({
    initialValues: {
      name: (data.representativeInfo && data.representativeInfo.name) || "",
      last_name:
        (data.representativeInfo && data.representativeInfo.last_name) || "",
      email: (data.representativeInfo && data.representativeInfo.email) || "",
      phoneCode:
        (data.representativeInfo && data.representativeInfo.phoneCode) || "",
      phone: (data.representativeInfo && data.representativeInfo.phone) || "",
      country:
        (data.representativeInfo && data.representativeInfo.country) || "",
      nationality:
        (data.representativeInfo && data.representativeInfo.nationality) || "",
      gender: (data.representativeInfo && data.representativeInfo.gender) || "",
      document_type:
        (data.representativeInfo && data.representativeInfo.document_type) ||
        "",
      indentity_number:
        (data.representativeInfo && data.representativeInfo.indentity_number) ||
        "",
      isPep:
        (data.representativeInfo && data.representativeInfo.isPep) || false,
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("Please Enter Your Name and Last Name"),
      last_name: yup.string().required("Please Enter Your Name and Last Name"),
      email: yup.string().email().required("Please Enter Your Email"),
      phoneCode: yup.number().required(""),
      phone: yup.number().positive().required("Please Enter Your Phone Number"),
      country: yup.string().required("Please Enter Your Country"),
      gender: yup.string().required("Debes seleccionar un genero"),
      document_type: yup
        .string()
        .required("Debes seleccionar un tipo de documento"),
      nationality: yup.string().required("Please Enter Your Nationality"),
      indentity_number: yup
        .string()
        .required("Please Enter Your Identity Document Number"),
      isPep: yup.boolean().required(""),
    }),
    onSubmit: (values: any) => {
      const newValues: any = {
        name: values.name,
        lastName: values.last_name,
        email: values.email,
        phoneCode: values.phoneCode,
        phone: values.phone,
        country: values.country,
        gender: values.gender,
        nationatily: values.nationality,
        documentType: values.document_type,
        indentityNumber: values.indentity_number,
        isPep: values.isPep,
        selfie: base64Selfie,
      };
      if (typeDocument === "PAS") {
        newValues.setBase64Front = null;
        newValues.setBase64Back = null;
        newValues.document1 = document1;
        if (documentValidated1 && selfieValidated) {
          onSubmit(newValues);
        } else {
          alert("Por favor verifica que todas las imagenes esten validadas");
        }
      } else {
        newValues.document1 = null;
        newValues.document_front = base64Front;
        newValues.document_back = base64Back;
        if (frontValidated && backValidated && selfieValidated) {
          onSubmit(newValues);
        } else {
          alert("Por favor verifica que todas las imagenes esten validadas");
        }
      }
    },
  });

  return (
    <React.Fragment>
      <Form onSubmit={formik.handleSubmit} autoComplete="off">
        <Row>
          {/* NOMBRE */}
          <FormGroup className="mb-3">
            <Row>
              <Col lg={6}>
                <Label htmlFor="name"> Nombre del Representante </Label>
                <Input
                  type="text"
                  id="name"
                  placeholder="Nombre completo del representante legal"
                  name="name"
                  value={formik.values.name || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.name && formik.errors.name ? true : false
                  }
                />
                {formik.touched.name && formik.errors.name ? (
                  <FormFeedback type="invalid">
                    {formik.errors.name}
                  </FormFeedback>
                ) : null}
              </Col>
              <Col lg={6}>
                <Label htmlFor="last_name"> Apellidos del Representante </Label>
                <Input
                  type="text"
                  id="last_name"
                  placeholder="Apellidos del Representante"
                  name="last_name"
                  value={formik.values.last_name || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.last_name && formik.errors.last_name
                      ? true
                      : false
                  }
                />
                {formik.touched.last_name && formik.errors.last_name ? (
                  <FormFeedback type="invalid">
                    {formik.errors.last_name}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
          </FormGroup>
          <Row>
            <Col lg={6}>
              {/* EMAIL */}
              <FormGroup className="mb-3">
                <Label htmlFor="kyclastname-input">Correo electrónico</Label>
                <Input
                  type="email"
                  id="email-input"
                  placeholder="Enter Email"
                  name="email"
                  value={formik.values.email || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.email && formik.errors.email ? true : false
                  }
                />
                {formik.touched.email && formik.errors.email ? (
                  <FormFeedback type="invalid">
                    {formik.errors.email}
                  </FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
            <Col lg={6}>
              {/* Phone number */}
              <FormGroup className="mb-3">
                <Label htmlFor="phone">Teléfono móvil </Label>
                <div className="d-flex gap-2">
                  {/* Dropdown con códigos de países */}
                  <select
                    style={{ width: "150px" }}
                    name="phoneCode"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.phoneCode || ""}
                    className="form-select w-[140px]"
                  >
                    <option value="" selected disabled>
                      Country Code
                    </option>
                    {countries.map((country) => (
                      <option
                        key={country.id}
                        value={"+" + country.phone_area_code}
                      >
                        {country.acronym} (+{country.phone_area_code})
                      </option>
                    ))}
                  </select>
                  <Input
                    type="number"
                    className="form-control"
                    name="phone"
                    id="phone"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    placeholder="Enter Phone number"
                    onBlur={formik.handleBlur}
                  />
                </div>
                {formik.touched.phone && formik.errors.phone ? (
                  <span className="text-danger">{formik.errors.phone}</span>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
          <FormGroup className="mb-3">
            <Row>
              {/* PAIS RESIDENCIA */}
              <Col lg={6}>
                <Label htmlFor="country"> Pais de Residencia </Label>
                <select
                  className="form-control"
                  name="country"
                  id="country"
                  value={formik.values.country || ""}
                  onChange={formik.handleChange}
                >
                  <option value="" selected disabled>
                    Elige una opcion
                  </option>
                  {countries.map((item) => (
                    <option
                      id={item.code_iso_31661}
                      value={item.code_iso_31661}
                    >
                      {item.name}
                    </option>
                  ))}
                </select>
                {formik.errors.country && formik.touched.country ? (
                  <span className="text-danger">{formik.errors.country}</span>
                ) : null}
              </Col>
              {/* NACIONALIDAD */}
              <Col lg={6}>
                <Label htmlFor="nationality"> Nacionalidad </Label>
                <select
                  className="form-control"
                  name="nationality"
                  id="nationality"
                  value={formik.values.nationality || ""}
                  onChange={formik.handleChange}
                >
                  <option value="" selected disabled>
                    Elige una opcion
                  </option>
                  {countries.map((item) => (
                    <option
                      id={item.code_iso_31661}
                      value={item.code_iso_31661}
                    >
                      {item.name}
                    </option>
                  ))}
                </select>
                {formik.errors.nationality && formik.touched.nationality ? (
                  <span className="text-danger">
                    {formik.errors.nationality}
                  </span>
                ) : null}
              </Col>
            </Row>
          </FormGroup>

          {/* GENERO */}
          <FormGroup className="mb-3">
            {/* GENDER */}
            <Col lg={6}>
              <Label htmlFor="gender"> Genero </Label>
              <select
                className="form-control"
                name="gender"
                id="gender"
                value={formik.values.gender || ""}
                onChange={formik.handleChange}
              >
                <option value="" selected disabled>
                  Elige una opcion
                </option>
                {gender.map((item) => (
                  <option id={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </select>
              {formik.errors.gender && formik.touched.gender ? (
                <span className="text-danger">{formik.errors.gender}</span>
              ) : null}
            </Col>
          </FormGroup>

          <FormGroup className="mb-3">
            <Row>
              {/* Tipo DOCUMENTO */}
              <Col lg={6}>
                <Label htmlFor="document_type"> Tipo de Documento </Label>
                <select
                  className="form-control"
                  name="document_type"
                  id="document_type"
                  value={formik.values.document_type || ""}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setTypeDocument(e.target.value);
                  }}
                >
                  <option value="" selected disabled>
                    Elige una opcion
                  </option>
                  {documentType.map((item: any) => (
                    <option key={item.code} value={item.code}>
                      {item.name}
                    </option>
                  ))}
                </select>
                {formik.errors.document_type && formik.touched.document_type ? (
                  <span className="text-danger">
                    {formik.errors.document_type}
                  </span>
                ) : null}
              </Col>
              {/* NUMERO DOCUMENTO INDENTIDAD */}
              <Col lg={6}>
                <Label htmlFor="indentity_number-input">
                  Numero de documento de identidad
                </Label>
                <Input
                  type="text"
                  id="indentity_number"
                  placeholder="Enter Identity document number"
                  name="indentity_number"
                  value={formik.values.indentity_number || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.indentity_number &&
                    formik.errors.indentity_number
                      ? true
                      : false
                  }
                />
                {formik.touched.indentity_number &&
                formik.errors.indentity_number ? (
                  <FormFeedback type="invalid">
                    {formik.errors.indentity_number}
                  </FormFeedback>
                ) : null}
              </Col>
            </Row>
          </FormGroup>

          {/* DOCUMENTOS FRENTE Y DORSO */}
          <Col lg={6} md={6} sm={6}>
            {typeDocument === "PAS" ? (
              <Row lg={12} md={12} sm={12}>
                <FormGroup className="mb-3">
                  <Label htmlFor="documento-input">Pasaporte</Label>
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <i
                      className="bx bx-upload"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <h5 className="font-size-14 mb-3">
                      Selecciona una imagen, tamaño maximo de 2MB
                    </h5>
                    {/* Input controlado por Dropzone */}
                    <input {...getDocInputProps()} />
                    <Button
                      type="button"
                      color={
                        selectedFileFront.length >= 1 ? "danger" : "primary"
                      }
                      disabled={selectedFileFront.length >= 1}
                      onClick={(e) => {
                        e.preventDefault();
                        openDocFront();
                      }}
                    >
                      Subir Archivo
                    </Button>

                    {/* Previsualización para documento */}
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}
                    >
                      {selectedFileFront.map((file, index) => (
                        <div
                          key={index}
                          style={{ position: "relative", marginBottom: "10px" }}
                        >
                          {/* Botón para eliminar */}
                          <button
                            type="button"
                            onClick={() => removeDoc(index)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "25px",
                              height: "25px",
                              cursor: "pointer",
                            }}
                          >
                            &times;
                          </button>
                          {/* {!documentValidated1 ? (
                          ) : null} */}
                          <img
                            src={file.preview}
                            alt={file.name}
                            style={{
                              maxWidth: "100%",
                              height: "200px",
                              borderRadius: "8px",
                            }}
                          />
                          <p>{file.name}</p>
                        </div>
                      ))}
                    </div>
                    {selectedFileFront.length > 0 && (
                      <Button
                        type="button"
                        color={documentValidated1 ? "success" : "primary"}
                        disabled={documentValidated1 || loadingPassport}
                        onClick={(e) => {
                          e.preventDefault();
                          validarPhotoUploaded("Passport");
                        }}
                        className="flex items-center gap-2"
                      >
                        {loadingPassport && (
                          <BiLoaderAlt className="animate-spin" />
                        )}
                        {documentValidated1 && !loadingPassport && (
                          <BiCheckCircle className="text-green-500" />
                        )}
                        {loadingPassport
                          ? "Cargando…"
                          : documentValidated1
                          ? "Validado"
                          : "Verificar"}
                      </Button>
                    )}
                  </div>
                </FormGroup>
              </Row>
            ) : (
              //FRENTE
              <Row lg={12} md={12} sm={12}>
                <FormGroup className="mb-3">
                  <Label htmlFor="documento-input">
                    Documento de identidad FRENTE
                  </Label>
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <i
                      className="bx bx-upload"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <h5 className="font-size-14 mb-3">
                      Selecciona una imagen, tamaño maximo de 2MB
                    </h5>
                    {/* Input controlado por Dropzone */}
                    <input {...getDocInputProps()} />
                    <Button
                      type="button"
                      color={
                        selectedFileFront.length >= 1 ? "danger" : "primary"
                      }
                      disabled={selectedFileFront.length >= 1}
                      onClick={(e) => {
                        e.preventDefault();
                        openDocFront();
                      }}
                    >
                      Subir Archivo
                    </Button>

                    {/* Previsualización para documento */}
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}
                    >
                      {selectedFileFront.map((file, index) => (
                        <div
                          key={index}
                          style={{ position: "relative", marginBottom: "10px" }}
                        >
                          {/* Botón para eliminar */}
                          <button
                            type="button"
                            onClick={() => removeDoc(index)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "25px",
                              height: "25px",
                              cursor: "pointer",
                            }}
                          >
                            &times;
                          </button>
                          {/* {!frontValidated ? (
                          ) : null} */}
                          <img
                            src={file.preview}
                            alt={file.name}
                            style={{
                              maxWidth: "100%",
                              height: "200px",
                              borderRadius: "8px",
                            }}
                          />
                          <p>{file.name}</p>
                        </div>
                      ))}
                    </div>
                    {selectedFileFront.length > 0 && (
                      <Button
                        type="button"
                        color={frontValidated ? "success" : "primary"}
                        disabled={frontValidated || loadingFront}
                        onClick={(e) => {
                          e.preventDefault();
                          validarPhotoUploaded("front");
                        }}
                        className="flex items-center gap-2"
                      >
                        {loadingFront && (
                          <BiLoaderAlt className="animate-spin" />
                        )}
                        {frontValidated && !loadingFront && (
                          <BiCheckCircle className="text-green-500" />
                        )}
                        {loadingFront
                          ? "Cargando…"
                          : frontValidated
                          ? "Validado"
                          : "Verificar"}
                      </Button>
                    )}
                  </div>
                </FormGroup>

                {/* EMPIEZA EL DORSO */}
                <FormGroup className="mb-3">
                  <Label htmlFor="documento-input">
                    Documento de identidad DORSO
                  </Label>
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <i
                      className="bx bx-upload"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <h5 className="font-size-14 mb-3">
                      Selecciona una imagen, tamaño maximo de 2MB
                    </h5>
                    {/* Input controlado por Dropzone */}
                    <input {...getDocInputPropsBack()} />
                    <Button
                      type="button"
                      color={
                        selectedFileBack.length >= 1 ? "danger" : "primary"
                      }
                      disabled={selectedFileBack.length >= 1}
                      onClick={(e) => {
                        e.preventDefault();
                        openDocBack();
                      }}
                    >
                      Subir Archivo
                    </Button>

                    {/* Previsualización para documento */}
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}
                    >
                      {selectedFileBack.map((file, index) => (
                        <div
                          key={index}
                          style={{ position: "relative", marginBottom: "10px" }}
                        >
                          {/* Botón para eliminar */}
                          <button
                            type="button"
                            onClick={() => removeDocBack(index)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "25px",
                              height: "25px",
                              cursor: "pointer",
                            }}
                          >
                            &times;
                          </button>
                          {/* {!backValidated ? (
                          ) : null} */}
                          <img
                            src={file.preview}
                            alt={file.name}
                            style={{
                              maxWidth: "100%",
                              height: "200px",
                              borderRadius: "8px",
                            }}
                          />
                          <p>{file.name}</p>
                        </div>
                      ))}
                    </div>
                    {selectedFileBack.length > 0 && (
                      <Button
                        type="button"
                        color={backValidated ? "success" : "primary"}
                        disabled={backValidated || loadingBack}
                        onClick={(e) => {
                          e.preventDefault();
                          validarPhotoUploaded("back");
                        }}
                        className="flex items-center gap-2"
                      >
                        {loadingBack && (
                          <BiLoaderAlt className="animate-spin" />
                        )}
                        {backValidated && !loadingBack && (
                          <BiCheckCircle className="text-green-500" />
                        )}
                        {loadingBack
                          ? "Cargando…"
                          : backValidated
                          ? "Validado"
                          : "Verificar Dorso"}
                      </Button>
                    )}
                  </div>
                </FormGroup>
              </Row>
            )}
          </Col>

          {/* SELFIE */}
          <Col lg={6} md={6} sm={12}>
            <FormGroup className="mb-3">
              <Label htmlFor="selfie-input">Selfie para verificación</Label>
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <i className="bx bx-upload" style={{ fontSize: "40px" }}></i>
                <h5 className="font-size-14 mb-3">
                  Selecciona una imagen, tamaño maximo de 2MB
                </h5>
                {/* Input controlado por Dropzone */}
                <input {...getSelfieInputProps()} />
                <Button
                  type="button"
                  color={selectedSelfie.length >= 1 ? "danger" : "primary"}
                  disabled={selectedSelfie.length >= 1}
                  onClick={(e) => {
                    e.preventDefault();
                    openSelfie();
                  }}
                >
                  Subir Archivo
                </Button>

                {/* Previsualización para documento */}
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {selectedSelfie.map((file, index) => (
                    <div
                      key={index}
                      style={{ position: "relative", marginBottom: "10px" }}
                    >
                      {/* Botón para eliminar */}
                      <button
                        type="button"
                        onClick={() => removeSelfie(index)}
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "25px",
                          height: "25px",
                          cursor: "pointer",
                        }}
                      >
                        &times;
                      </button>
                      {/* {!selfieValidated ? (
                      ) : null} */}
                      <img
                        src={file.preview}
                        alt={file.name}
                        style={{
                          maxWidth: "100%",
                          height: "200px",
                          borderRadius: "8px",
                        }}
                      />
                      <p>{file.name}</p>
                    </div>
                  ))}
                </div>
                {selectedSelfie.length > 0 && (
                  <Button
                    type="button"
                    color={selfieValidated ? "success" : "primary"}
                    disabled={selfieValidated || loadingSelfie}
                    onClick={(e) => {
                      e.preventDefault();
                      validarPhotoUploaded("selfie");
                    }}
                    className="flex items-center gap-2"
                  >
                    {loadingSelfie && <BiLoaderAlt className="animate-spin" />}
                    {selfieValidated && !loadingSelfie && (
                      <BiCheckCircle className="text-green-500" />
                    )}
                    {loadingSelfie
                      ? "Cargando…"
                      : selfieValidated
                      ? "Validado"
                      : "Verificar"}
                  </Button>
                )}
              </div>
            </FormGroup>
          </Col>

          {/* ISPEP */}
          <FormGroup className="mb-4">
            {/* Título */}
            <Label tag="h6">Información sobre PEP</Label>
            {/* Texto largo con scroll */}
            <div
              style={{
                maxHeight: "120px",
                overflowY: "auto",
                padding: "8px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <p>
                De acuerdo con la Ley Contra el Lavado de Dinero y de Activos y
                las normas de la Superintendencia del Sistema Financiero (SSF),
                se considera PEP a:
                <br />
                <br />
                “Las personas naturales que desempeñan o han desempeñado
                funciones públicas destacadas en un país o en una organización
                internacional, incluyendo jefes de Estado o de Gobierno, altos
                funcionarios gubernamentales, judiciales o militares, altos
                ejecutivos de empresas estatales o importantes partidos
                políticos.”
              </p>
            </div>
            {/* Checkbox */}
            <FormGroup check className="mb-3 mt-3">
              <Label check>
                <Input
                  type="checkbox"
                  name="isPep"
                  onChange={formik.handleChange}
                  checked={formik.values.isPep}
                  value={formik.values.isPep || ""}
                />
                Marque acá si usted es una{" "}
                <span
                  style={{ color: "blue", textDecorationLine: "underline" }}
                >
                  persona políticamente expuesta (PEP)
                </span>
              </Label>
              {formik.touched.isPep && formik.errors.isPep ? (
                <div className="text-danger">{formik.errors.isPep}</div>
              ) : null}
            </FormGroup>
          </FormGroup>
        </Row>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link
            to="/select-type"
            type="button"
            className="btn btn-secondary me-2"
          >
            Regresar
          </Link>
          <Button type="submit" className="btn btn-primary">
            Siguiente
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default RepresentativeInformation;
